import { render, staticRenderFns } from "./LogoutItem.vue?vue&type=template&id=5e5b914b&"
import script from "./LogoutItem.vue?vue&type=script&lang=js&"
export * from "./LogoutItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e5b914b')) {
      api.createRecord('5e5b914b', component.options)
    } else {
      api.reload('5e5b914b', component.options)
    }
    module.hot.accept("./LogoutItem.vue?vue&type=template&id=5e5b914b&", function () {
      api.rerender('5e5b914b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/sidebar/nav-menu-items/LogoutItem.vue"
export default component.exports